import { render, staticRenderFns } from "./LaundryComplaintHandling.vue?vue&type=template&id=7e820a24&scoped=true"
import script from "./LaundryComplaintHandling.vue?vue&type=script&lang=js"
export * from "./LaundryComplaintHandling.vue?vue&type=script&lang=js"
import style0 from "./LaundryComplaintHandling.vue?vue&type=style&index=0&id=7e820a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e820a24",
  null
  
)

export default component.exports